export default "__VITE_ASSET__CB$nsx1O__"